import { AccountIcon } from "@fla/components";
import { Modal } from "components";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import Register from ".";

export default function RegisterModal() {
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  const onClose = () => setOpen(false);
  const onOpen = () => setOpen(true);

  return (
    <>
      <div
        className="bg-gray/25 hover:bg-gray-dark/25 max-w-2xl py-5 px-5 md:p-10 mx-auto rounded-lg flex flex-col items-center space-y-5 cursor-pointer"
        onClick={onOpen}
      >
        <AccountIcon strokeColor="text-gray-dark" />
        <p className="font-bold text-[17px] text-center">Click To Create An Account To Save Your Progress</p>
      </div>
      <Modal widthCSS="max-w-md" classes="!px-10 !pb-10" isOpen={open} onClose={onClose}>
        <Register as="modal" href={pathname} />
      </Modal>
    </>
  );
}
